import React, { ReactNode } from 'react';

import { alpha, darken, Drawer as MuiDrawer, Theme } from '@mui/material';
import { DrawerProps as MuiDrawerProps } from '@mui/material/Drawer';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    '& .MuiPaper-root': {
      transition: 'transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms',
    },
    '& .MuiBackdrop-root': {
      backgroundColor: darken(alpha(theme.palette.background.default, 0.6), 1),
    },
  },
  drawer: {
    paddingLeft: theme.spacing(3),
    paddingTop: theme.spacing(3),
    width: '320px',
  },
}));

export interface DrawerProps extends MuiDrawerProps {
  children: ReactNode;
}

export function Drawer(props: DrawerProps): JSX.Element {
  const { children, ...rest } = props;
  const classes = useStyles();

  return (
    <MuiDrawer
      keepMounted
      anchor="left"
      classes={{
        root: classes.root,
        paper: clsx({
          [classes.drawer]: true,
        }),
      }}
      {...rest}
    >
      {children}
    </MuiDrawer>
  );
}
